/**
 * tab点击循环menulist获取menu_id的递归
 */
const tabRecursion = (_target, list) => {
    for (let i in list) {
        if (_target == list[i].url) {
            return list[i].id;
        } else if (list[i].child && list[i].child.length) {
            let func = tabRecursion(_target, list[i].child);
            // let func = this.tabRecursion(_target, list[i].child);
            if (func) {
                return func;
            }
        }
    }
    return "";
};
export default tabRecursion;
